import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  display: inline;
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 0.5rem;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.37px;
  padding: 0 20px;
  white-space: normal;
  position: absolute;
  top: calc(50% + 27px);
  width: 80%;
  transform: translate(-50%, 0);

  ${media.medium`
    font-size: 0.7rem;
    line-height: 18px;
    top: calc(50% + 2.5vw);
    width: auto;
  `}
`;
